<template>
  <form>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-toolbar>
          <v-icon>shopping_basket</v-icon>
          <v-toolbar-title class="font-weight-light"
            >&nbsp;Alta de Consulta xx para Crédito</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                icon
                color="red"
                v-on="on"
                @click="setStatusTareaFrecuente(action)">
                <v-icon v-if="action.esFrecuente">favorite</v-icon>
                <v-icon v-else>favorite_border</v-icon>
              </v-btn>
            </template>
            <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
            <span v-else>Agregar a Tareas Frecuentes</span>
          </v-tooltip>
        </v-toolbar>

        <v-container fluid>
          <v-row>
            <v-col cols="8">
              <v-row v-if="selectedCanalVenta">
                <v-col>
                  <v-card dark color="purple">
                    <v-card-text>
                      <div>
                        Solicitud para
                        <v-chip :color="selectedEmpresa.color">
                          {{ selectedEmpresa.nombre }}
                        </v-chip>
                        , en {{ selectedCanalVenta.nombre }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-if="infoCrediticia">
                <v-col>
                  <v-card dark color="green darken-3">
                    <v-card-text>
                      <div>{{ infoPersona }}</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-if="infoCrediticia">
                <v-col>
                  <v-card dark color="blue ligthten-3">
                    <v-card-text>
                      <div>{{ infoEmpleo }}</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  model.consultaCredito && model.consultaCredito.estado != ''
                ">
                <v-col>
                  <v-card dark color="orange ligthten-1">
                    <v-card-text>
                      <div>{{ infoconsultaCredito }}</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <app-info-consulta-motor-siisa
                :consultaCredito="model.consultaCredito"
                v-if="motorSiisaActivo"></app-info-consulta-motor-siisa>
            </v-col>
          </v-row>
        </v-container>

        <div class="text-xs-center">
          <v-progress-linear
            v-show="loadingProgress"
            indeterminate></v-progress-linear>
        </div>

        <v-card-text>
          <v-stepper v-model="step">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" step="1" color="green"
                >Datos del Solicitante</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2" color="yellow">{{
                captionStep2
              }}</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 3" step="3" color="orange">{{
                captionStep3
              }}</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 4" step="4" color="orange">{{
                captionStep4
              }}</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-layout wrap>
                <v-flex>
                  <!-- PASO 1 -->
                  <v-stepper-content step="1">
                    <ValidationObserver ref="paso1">
                      <v-card class="mb-5">
                        <v-container fluid>
                          <v-row>
                            <v-col cols="12" md="6" lg="4">
                              <v-autocomplete
                                v-model="model.empresaId"
                                :items="listEmpresas"
                                autocomplete="disabled"
                                item-text="nombre"
                                item-value="id"
                                label="Nueva Solicitud para la Empresa"
                                :menu-props="{
                                  minWidth: '200',
                                }"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6" lg="4">
                              <v-autocomplete
                                v-model="model.canalVentaId"
                                :items="listCanalesVenta"
                                autocomplete="disabled"
                                item-text="nombre"
                                item-value="id"
                                label="a través del Canal de Venta"
                                :menu-props="{
                                  minWidth: '200',
                                }"></v-autocomplete>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" md="6" lg="4">
                              <v-autocomplete
                                v-model="model.productoId"
                                :items="listProductosDisponibles"
                                @change="selectedProductoChanged"
                                autocomplete="disabled"
                                item-text="productoDescripcion"
                                item-value="productoId"
                                label="¿Qué Producto va a solicitar?"
                                :menu-props="{
                                  minWidth: '200',
                                }"></v-autocomplete>
                              <v-chip
                                v-if="
                                  hayProductosNoDisponibles &&
                                  $store.state.debugModeOn
                                "
                                color="red"
                                text-color="white"
                                @click="showProductosNoDisponibles = true"
                                >Hay Productos no disponibles</v-chip
                              >
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12">
                              <h3>Ingrese los datos del Solicitante</h3>
                            </v-col>
                          </v-row>

                          <v-row align="center">
                            <v-col cols="12" md="3" lg="2">
                              <v-radio-group v-model="ingresoPor">
                                <v-radio
                                  label="Documento"
                                  class="caption"
                                  key="documento"
                                  value="documento"></v-radio>
                                <v-radio
                                  label="Cuil"
                                  class="caption"
                                  key="cuil"
                                  value="cuil"></v-radio>
                              </v-radio-group>
                            </v-col>

                            <v-col
                              cols="12"
                              md="4"
                              lg="2"
                              v-if="ingresoPor == 'documento'">
                              <v-text-field
                                label="Documento"
                                v-model="model.documento"
                                append-icon="search"
                                @click:append="
                                  buscarPersonaPorDocumento(model.documento)
                                "
                                autocomplete="disabled"
                                v-validate="'required'"
                                data-vv-name="documento"></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                              lg="2"
                              v-if="ingresoPor == 'documento'">
                              <v-autocomplete
                                v-model="model.personaDto.tipoSexoId"
                                :items="listSexos"
                                autocomplete="disabled"
                                item-text="descripcion"
                                item-value="id"
                                label="Sexo"
                                :menu-props="{
                                  minWidth: '200',
                                }"></v-autocomplete>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              lg="2"
                              v-if="ingresoPor == 'cuil'">
                              <v-text-field
                                label="CUIL"
                                v-model="model.cui"
                                append-icon="search"
                                @click:append="
                                  buscarPersonaPorDocumento(model.cui)
                                "
                                v-validate="'required'"
                                data-vv-name="cuil"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" lg="2">
                              <v-chip
                                color="green"
                                text-color="white"
                                v-if="
                                  infoCrediticia != null &&
                                  infoCrediticia.tipoCalificacionId == 1
                                "
                                >{{
                                  infoCrediticia.tipoCalificacionDescripcion
                                }}</v-chip
                              >
                              <v-chip
                                color="orange"
                                text-color="white"
                                v-if="
                                  infoCrediticia != null &&
                                  infoCrediticia.tipoCalificacionId > 1
                                "
                                >{{
                                  infoCrediticia.tipoCalificacionDescripcion
                                }}</v-chip
                              >
                            </v-col>
                            <v-col cols="12" md="6" lg="3">
                              <v-chip
                                color="blue"
                                text-color="white"
                                v-if="tieneConsultasAprobadas"
                                @click="showConsultasAprobadas = true"
                                >Hay Consultas con Cupo para esta
                                Persona</v-chip
                              >
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="4" lg="3">
                              <ValidationProvider
                                name="nombre"
                                v-if="motorSiisaActivo">
                                <v-text-field
                                  type="text"
                                  label="Nombre"
                                  v-model="model.personaDto.nombre"
                                  autocomplete="nope"
                                  hint="Puede dejar el Nombre vacío, se intentará recuperar desde el motor"
                                  persistent-hint
                                  data-vv-name="nombre"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"></v-text-field>
                              </ValidationProvider>
                              <ValidationProvider
                                name="nombre"
                                rules="required"
                                v-if="!motorSiisaActivo">
                                <v-text-field
                                  type="text"
                                  label="Nombre"
                                  v-model="model.personaDto.nombre"
                                  autocomplete="nope"
                                  data-vv-name="nombre"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="4" lg="3">
                              <ValidationProvider
                                name="apellido"
                                v-if="motorSiisaActivo">
                                <v-text-field
                                  label="Apellido"
                                  v-model="model.personaDto.apellido"
                                  autocomplete="nope"
                                  hint="Puede dejar el Apellido vacío, se intentará recuperar desde el motor"
                                  persistent-hint
                                  data-vv-name="apellido"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"></v-text-field>
                              </ValidationProvider>
                              <ValidationProvider
                                name="apellido"
                                rules="required"
                                v-if="!motorSiisaActivo">
                                <v-text-field
                                  label="Apellido"
                                  v-model="model.personaDto.apellido"
                                  autocomplete="nope"
                                  data-vv-name="apellido"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"></v-text-field>
                              </ValidationProvider>
                            </v-col>

                            <v-col cols="12" md="4" lg="3">
                              <ValidationProvider
                                name="ingreso mensual"
                                rules="required|decimal:2|min_value:1000">
                                <v-text-field
                                  label="Ingreso Neto Mensual"
                                  v-model="model.personaDto.empleo.ingresoNeto"
                                  data-vv-name="ingreso mensual"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"></v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" md="6" lg="6">
                              <ValidationProvider
                                name="movimientos"
                                rules="required">
                                <v-autocomplete
                                  v-model="model.entidadFinancieraId"
                                  :items="listEntidadesFinancieras"
                                  clearable
                                  item-text="descripcion"
                                  item-value="id"
                                  label="Banco"
                                  :menu-props="{ minWidth: '200' }"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"></v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="4" lg="3">
                              <ValidationProvider
                                name="movimientos"
                                rules="decimal:2">
                                <v-text-field
                                  label="Movimientos"
                                  v-model="model.movimientos"
                                  data-vv-name="movimientos"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"></v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                        </v-container>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" @click="nextStep(1)">
                            Consultar
                          </v-btn>

                          <v-btn text @click="cancelar">Cancelar</v-btn>
                        </v-card-actions>
                      </v-card>
                    </ValidationObserver>
                  </v-stepper-content>

                  <!-- PASO 2 (CARGA REDUCIDA)-->
                  <v-stepper-content step="2">
                    <v-card class="mb-5">
                      <v-container fluid>
                        <v-row>
                          <div class="title">
                            Para Finalizar, especifique los siguientes datos
                          </div>
                        </v-row>
                        <v-row>
                          <v-container>
                            <v-checkbox
                              v-model="showAgregar"
                              label="Agregar Archivos"></v-checkbox>

                            <div v-if="showAgregar">
                              <v-file-input
                                v-model="archivosASubir"
                                placeholder="Seleccione los archivos a subir"
                                label="Archivos a subir"
                                chips
                                multiple
                                counter
                                show-size
                                prepend-icon="search">
                              </v-file-input>
                            </div>
                          </v-container>
                        </v-row>
                        <v-row>
                          <v-text-field
                            v-model="model.observaciones"
                            label="Si es necesario puede ingresar algún comentario para el analista"></v-text-field>
                        </v-row>
                      </v-container>

                      <v-card-actions>
                        <v-btn
                          v-if="!model.consultaCredito"
                          color="primary"
                          @click="step = step - 1">
                          Volver
                        </v-btn>

                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          @click="confirmarAltaConsulta"
                          :disabled="!puedeContinuarPaso2">
                          Confirmar Carga
                        </v-btn>

                        <v-btn text @click="cancelar">Cancelar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-stepper-content>

                  <!-- PASO 3 -->
                  <v-stepper-content step="3" v-if="model.trabaja">
                    <v-card class="mb-5">
                      <v-layout>
                        <v-flex xs12>
                          <v-card dark color="blue ligthten-3">
                            <v-card-text>
                              <div>{{ infoCredito }}</div>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>

                      <v-container fluid>
                        <ValidationObserver ref="paso3">
                          <v-row>
                            <v-col cols="8">
                              <v-row>
                                <v-col>
                                  <v-autocomplete
                                    v-model="model.planId"
                                    :items="listPlanesDisponibles"
                                    @change="selectedPlanChanged"
                                    :disabled="user.esComer"
                                    item-text="planNombre"
                                    item-value="planId"
                                    label="Planes Disponibles"
                                    :menu-props="{
                                      minWidth: '200',
                                    }"></v-autocomplete>

                                  <v-chip
                                    v-if="
                                      hayPlanesNoDisponibles &&
                                      $store.state.debugModeOn
                                    "
                                    color="red"
                                    text-color="white"
                                    @click="showPlanesNoDisponibles = true"
                                    >Hay Planes no disponibles</v-chip
                                  >
                                </v-col>
                              </v-row>

                              <!-- <v-row>
                              <v-col cols="3">
                                <v-switch v-model="model.modificaOferta" label="Modificar Oferta"></v-switch>
                              </v-col>
                              <v-col>
                                <v-text-field v-if="model.modificaOferta" label="Ingrese el motivo para la modificación" v-model="model.motivoModificacionOferta" ></v-text-field>
                              </v-col>
                            </v-row> -->

                              <v-row
                                v-if="
                                  model.consultaCredito.cupo > 0 ||
                                  model.consultaCredito.topeProducto > 0
                                ">
                                <v-col>
                                  <v-chip label color="warning"
                                    >Recuerde que tiene un Cupo de
                                    {{
                                      model.consultaCredito.cupo | currency
                                    }}</v-chip
                                  >
                                  <v-chip
                                    label
                                    color="pink"
                                    dark
                                    v-if="
                                      model.consultaCredito.topeProducto > 0
                                    "
                                    >y un Tope de
                                    {{
                                      model.consultaCredito.topeProducto
                                        | currency
                                    }}</v-chip
                                  >
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col>
                                  <!-- <v-radio-group row v-model="ingresoPorMonto" :disabled="!model.modificaOferta"> -->
                                  <v-radio-group row v-model="ingresoPorMonto">
                                    <v-radio
                                      label="Ingresar Monto"
                                      value="true"></v-radio>
                                    <v-radio
                                      label="Ingresar Cuota Máxima"
                                      value="false"></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col>
                                  <v-text-field
                                    label="Solicita"
                                    v-model="capitalIngresado"
                                    v-show="ingresoPorMonto == 'true'"
                                    persistent-hint
                                    :hint="
                                      model.consultaCredito.topeProducto
                                        ? 'Importe Máximo $' +
                                          model.consultaCredito.topeProducto
                                        : ''
                                    "></v-text-field>
                                  <v-text-field
                                    label="Cuota Máxima"
                                    persistent-hint
                                    :hint="
                                      model.consultaCredito.cupo
                                        ? 'Importe Máximo $' +
                                          model.consultaCredito.cupo
                                        : ''
                                    "
                                    v-model="importeCuotaMaximaIngresado"
                                    v-show="
                                      ingresoPorMonto == 'false'
                                    "></v-text-field>
                                </v-col>
                                <v-col>
                                  <v-btn
                                    color="blue-grey"
                                    outlined
                                    @click="calcularOpcionesPlan">
                                    Recalcular
                                  </v-btn>
                                </v-col>
                              </v-row>
                              <!-- <v-row>
                              <v-col>
                                <v-text-field  label="Renovación" v-model="model.montoRenovacion"></v-text-field>
                              </v-col>
                              <v-col>
                                <v-text-field  label="Retención" v-model="model.montoRetencion"></v-text-field>
                              </v-col>
                            </v-row> -->
                            </v-col>

                            <v-col>
                              <v-layout column>
                                <v-flex>
                                  <v-card>
                                    <v-card-title>
                                      <h6 v-show="ingresoPorMonto == 'true'">
                                        Puede Solicitar $
                                        {{ capitalIngresado }} en
                                      </h6>
                                      <h6 v-show="ingresoPorMonto == 'false'">
                                        Puede Solicitar hasta
                                      </h6>
                                    </v-card-title>
                                    <v-card-text>
                                      <v-radio-group row v-model="indiceOferta">
                                        <v-radio
                                          v-for="item in opcionesPlanes"
                                          @change="setCuotaSeleciconada(item)"
                                          :key="item.indice"
                                          :label="item.oferta"
                                          :value="item.indice"></v-radio>
                                      </v-radio-group>
                                    </v-card-text>
                                    <v-card-actions>
                                      <h6 v-show="ingresoPorMonto == 'false'">
                                        * si quiere un monto en particular,
                                        seleccione Ingreso por Monto
                                      </h6>
                                    </v-card-actions>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-col>
                          </v-row>
                        </ValidationObserver>
                      </v-container>
                      <v-snackbar
                        v-model="hayErroresPolitica"
                        color="red"
                        bottom
                        :timeout="60000">
                        {{ errorPolitica }}
                        <v-btn dark text @click="hayErroresPolitica = false">
                          Cerrar
                        </v-btn>
                      </v-snackbar>
                    </v-card>

                    <v-card-actions>
                      <!-- <v-btn
                          color="primary"
                          @click="step = step-1"
                        >
                          Volver
                        </v-btn> -->

                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        @click="nextStep(3)"
                        :disabled="!puedeContinuarPaso3">
                        Siguiente Paso
                      </v-btn>

                      <v-btn text @click="cancelar">Cancelar</v-btn>
                    </v-card-actions>
                  </v-stepper-content>

                  <!-- PASO 4 -->
                  <v-stepper-content step="4">
                    <v-card class="mb-5">
                      <v-layout>
                        <v-flex xs12>
                          <v-card dark color="blue ligthten-3">
                            <v-card-text>
                              <div>{{ infoCredito }}</div>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>

                      <v-container fluid>
                        <v-layout>
                          <v-flex xs8>
                            <v-row v-if="model.calificacionPersonaId <= 1">
                              <v-col cols="6">
                                <h3>
                                  El solicitante es Nuevo, por lo que debe
                                  completar el Legajo del mismo
                                </h3>
                              </v-col>
                              <v-col>
                                <v-btn outlined @click="showLegajo = true"
                                  >Completar Legajo</v-btn
                                >
                              </v-col>
                              <v-col>
                                <v-icon v-if="legajoCheck" color="green"
                                  >done_outline</v-icon
                                >
                              </v-col>
                            </v-row>

                            <v-row v-if="model.calificacionPersonaId > 1">
                              <v-col cols="6">
                                <h3>
                                  El solicitante ya es Cliente, revise el legajo
                                  y actualice los datos que sean necesarios
                                </h3>
                              </v-col>
                              <v-col>
                                <v-btn outlined @click="showLegajo = true"
                                  >Completar Legajo</v-btn
                                >
                              </v-col>
                              <v-col>
                                <v-icon v-if="legajoCheck" color="green"
                                  >done_outline</v-icon
                                >
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col>
                                <h3>Datos de la Cuenta Bancaria</h3>
                              </v-col>
                            </v-row>

                            <v-row no-gutters>
                              <v-col cols="3">
                                <v-switch
                                  v-model="model.solicitaDebito"
                                  label="Solicita Débito en Cuenta ">
                                </v-switch>
                              </v-col>

                              <!-- <v-col cols="2">
                            <v-autocomplete v-model="model.diaCobroId" :items="listDiasCobro" 
                                  item-text="descripcion" item-value="id" label="Día de Cobro"  :menu-props="{minWidth:'200'}"></v-autocomplete>
                          </v-col> -->
                            </v-row>
                            <v-row v-if="model.solicitaDebito" no-gutters>
                              <v-col cols="6">
                                <!-- <v-text-field label="CBU" v-model="model.cbu" counter ></v-text-field> -->
                                <app-datos-debito-credito
                                  :standAloneMode="false"
                                  :personaId="model.personaId"
                                  :creditoId="model.consultaCredito.id"
                                  :tipoSituacionLaboralId="
                                    model.personaDto.tipoSituacionLaboralId
                                  "
                                  :documento="model.personaDto.documento"
                                  :subSituacionLaboralId="
                                    subSituacionLaboralEmpleo
                                  "
                                  :cuentaSeleccionada="
                                    model.cuentaDebito
                                  "></app-datos-debito-credito>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <h3>
                                  Para finalizar, especifique los siguientes
                                  datos
                                </h3>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col>
                                <ValidationProvider
                                  name="medio de pago"
                                  rules="required">
                                  <v-autocomplete
                                    v-model="model.tipoMedioPagoId"
                                    :items="listMediosPago"
                                    :disabled="puedeModificarMedioCobro"
                                    item-text="descripcion"
                                    item-value="id"
                                    label="El desembolso del crédito será mediante"
                                    :menu-props="{ minWidth: '200' }"
                                    data-vv-name="medio de pago"
                                    slot-scope="{ errors, valid }"
                                    :error-messages="errors"
                                    :success="valid"></v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col>
                                <ValidationProvider
                                  name="forma de llegada"
                                  rules="required">
                                  <v-autocomplete
                                    v-model="model.tipoFormaLlegadaId"
                                    :items="listFormasLlegada"
                                    item-text="descripcion"
                                    item-value="id"
                                    label="Indique cómo llegó el solicitante"
                                    :menu-props="{ minWidth: '200' }"
                                    data-vv-name="forma de llegada"
                                    slot-scope="{ errors, valid }"
                                    :error-messages="errors"
                                    :success="valid"></v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col>
                                <ValidationProvider
                                  name="motivo de la solicitud"
                                  rules="required">
                                  <v-autocomplete
                                    v-model="model.tipoMotivoSolicitudId"
                                    :items="listDestinosCredito"
                                    item-text="descripcion"
                                    item-value="id"
                                    label="Indique cuál es el destino del crédito"
                                    :menu-props="{ minWidth: '200' }"
                                    data-vv-name="motivo de la solicitud"
                                    slot-scope="{ errors, valid }"
                                    :error-messages="errors"
                                    :success="valid"></v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-container>
                                <v-checkbox
                                  v-model="showAgregar"
                                  label="Agregar Archivos"></v-checkbox>

                                <div v-if="showAgregar">
                                  <v-file-input
                                    v-model="archivosASubir"
                                    placeholder="Seleccione los archivos a subir"
                                    label="Archivos a subir"
                                    chips
                                    multiple
                                    prepend-icon="search">
                                  </v-file-input>
                                </div>
                              </v-container>
                            </v-row>

                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="model.observaciones"
                                  label="Si es necesario puede ingresar algún comentario para el analista"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-flex>
                          <v-flex xs4 v-if="step == 4">
                            <v-container>
                              <v-layout wrap>
                                <v-flex>
                                  <v-text-field
                                    v-model="model.politicaComercialId"
                                    label="PoliticaId"
                                    v-if="
                                      $store.state.debugModeOn
                                    "></v-text-field>
                                  <app-validador-politica-comercial
                                    v-if="model.politicaComercialId > 0"
                                    :politica="this.politicaComercial"
                                    :ParametrosAValidar="model"
                                    v-bind:PoliticaAprobada.sync="
                                      politicaAprobada
                                    "
                                    v-bind:ErroresPolitica.sync="errorPolitica"
                                    v-bind:AutorizadoPorExcepcion.sync="
                                      model.seAutorizoPorExcepcion
                                    "
                                    v-bind:AutorizadoPorUsuario.sync="
                                      model.usuarioQueAutorizo
                                    "
                                    v-bind:AutorizadoPorMotivo.sync="
                                      model.motivoAutorizacion
                                    "></app-validador-politica-comercial>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>

                    <v-card-actions>
                      <v-btn color="primary" @click="step = step - 1">
                        Volver
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="confirmarAlta">
                        Confirmar Operación
                      </v-btn>

                      <v-btn text @click="cancelar">Cancelar</v-btn>
                    </v-card-actions>
                  </v-stepper-content>
                </v-flex>
              </v-layout>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
      <app-loading :loading="loading"></app-loading>

      <!-- productos no disponibles -->
      <v-dialog v-model="showProductosNoDisponibles" width="600">
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="headline">Productos No disponibles</v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-list>
                <v-list-item
                  v-for="item in listProductos.filter((p) => !p.estaDisponible)"
                  :key="item.productoId">
                  <template>
                    <h5>{{ item.productoDescripcion }}:</h5>
                    <div class="caption">{{ item.motivoNoDisponible }}</div>
                  </template>
                </v-list-item>
              </v-list>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- planes no disponibles -->
      <v-dialog v-model="showPlanesNoDisponibles" width="600">
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="headline">Planes No disponibles</v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-list>
                <v-list-item
                  v-for="item in listPlanes.filter((p) => !p.estaDisponible)"
                  :key="item.planId">
                  <template>
                    <h5>{{ item.planNombre }}:</h5>
                    <div class="caption">{{ item.motivoNoDisponible }}</div>
                  </template>
                </v-list-item>
              </v-list>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- legajo  -->
      <v-dialog v-model="showLegajo" width="1000" persistent>
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="headline">Legajo de la Persona</v-card-title>
          <v-card-text>
            <legajo-persona
              :value="model.personaDto"
              :visible="showLegajo"
              :legajoGuardado="legajoGuardado"></legajo-persona>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- consultas aprobadas con cupo -->
      <v-dialog v-model="showConsultasAprobadas" width="600">
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="headline"
            >Consultas Aprobadas para la Persona</v-card-title
          >
          <v-card-text>
            <v-layout wrap>
              <v-list>
                <v-list-item
                  v-for="item in listConsultasAprobadas"
                  :key="item.Id"
                  two-line>
                  <v-list-item-content>
                    <v-list-item-title
                      >Cupo Aprobado: $ {{ item.cupo }}</v-list-item-title
                    >
                    <v-list-item-subtitle
                      ><div class="caption">Producto: {{ item.producto }}</div>
                      <div class="caption">
                        Fecha: {{ item.fechaIngreso | formatDate }}
                      </div></v-list-item-subtitle
                    >
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn color="green" dark @click="retomarConsulta(item)">
                      Retomar
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- save progress -->
      <v-dialog v-model="showSaveProgress" width="400">
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="headline">Guardando Consulta...</v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-row>
                <v-col> Registrando Operación... </v-col>
                <v-col>
                  <v-progress-circular
                    v-if="saving"
                    indeterminate
                    color="red"></v-progress-circular>
                  <v-icon large v-else>done</v-icon>
                </v-col>
              </v-row>
              <v-row v-if="archivosASubir.length > 0">
                <v-col> Subiendo archivos... </v-col>
                <v-col>
                  <v-progress-circular
                    v-if="uploading"
                    indeterminate
                    color="red"></v-progress-circular>
                  <v-icon large v-else>done</v-icon>
                </v-col>
              </v-row>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Ingreso Por Monto: {{ ingresoPorMonto }}
      <p></p>
      Monto: {{ capitalIngresado }}
      <p></p>
      Cta Maxima: {{ importeCuotaMaximaIngresado }}
      <p></p>
      Errores Política: {{ errorPolitica }} Politica Aprobada:
      {{ politicaAprobada }}

      Model: {{ model }}
      <p></p>
    </template>
  </form>
</template>

<script>
import Vue from "vue";
import { http } from "@/axios";
import { ValidationObserver, ValidationProvider } from "vee-validate";

import legajoVirtualService from "@/services/legajoVirtual.service";

import LegajoPersona from "./DatosLegajo";

import { mapGetters, mapMutations, mapActions } from "vuex";
import { format } from "date-fns";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    "legajo-persona": LegajoPersona,
  },
  props: ["retomarConsultaId"],
  data() {
    return {
      step: 0,
      loading: false,
      loadingProgress: false, // Lo uso para la progress bar
      editMode: true,
      showProductosNoDisponibles: false,
      showPlanesNoDisponibles: false,
      showLegajo: false,
      model: {
        personaId: null,
        cuentaDebito: {},
        solicitaDebito: false,
        tipoMedioPagoId: 1,
        planId: 0,
      },
      selectedPersonaBusqueda: null,
      infoCrediticia: null,
      importe: 0,
      listSituacionesLaborales: [],
      listEmpresas: [],
      listCanalesVentaHabilitados: [],
      listProductos: [],
      listProductosDisponibles: [],
      listPlanes: [],
      listPlanesDisponibles: [],
      listSexos: [],
      listMediosPago: [],
      listDiasCobro: [],
      listFormasLlegada: [],
      listDestinosCredito: [],
      listEntidadesFinancieras: [],
      ingresoPorMonto: "true",
      politicaComercial: {},
      opcionesPlanes: [],
      cuotaSeleccionada: { cuotas: 0 },
      politicaAprobada: false,
      errorPolitica: "",
      hayErroresPolitica: false,
      legajoCheck: false,
      indiceOferta: 0,
      capitalIngresado: 0,
      importeCuotaMaximaIngresado: 0,
      showAgregar: false,
      archivosASubir: [],
      captionStep2: "",
      captionStep3: "",
      captionStep4: "",
      motorSiisaActivo: false,
      showConsultasAprobadas: false,
      listConsultasAprobadas: [],
      showSaveProgress: false,
      saving: false,
      uploading: false,
      ingresoPor: "documento",
    };
  },
  async created() {
    this.motorSiisaActivo =
      this.$store.state.parametrosGenerales.conexionMotorSiisa;
    this.ingresoPor =
      this.$store.state.parametrosGenerales.ingresoPorDefectoPor;

    this.clear();
    await this.loadCanalesVentaHabilitados();
    this.loadSituacionesLaborales();
    this.loadSexo();
    this.loadDiasCobro();
    this.loadMediosPago();
    this.loadFormasLlegada();
    this.loadDestinosCredito();
    this.loadEntidadesFinancieras();

    this.showAgregar = this.user.esComer; // al usuario comer siempre se le obliga adjuntar

    if (this.retomarConsultaId) {
      await this.retomarConsultaCredito(this.retomarConsultaId);
    }
  },
  watch: {
    "model.canalVentaId": async function () {
      // cargo los productos disponibles
      await this.loadProductosDisponibles();
    },
    "model.planId": async function () {
      // si el plan tiene como medio de cobro Debito en Cuenta, pongo como predeterminado el tilde de solicita debito
      // y la forma de pago x transferencia
      var plan = this.listPlanesDisponibles.find(
        (i) => i.planId == this.model.planId
      );

      console.log("plan");
      console.log(plan);
      if (plan.requiereDebitoEnCuenta) {
        this.model.solicitaDebito = true;
        this.model.tipoMedioPagoId = 2;
      } else {
        this.model.solicitaDebito = false;
        this.model.tipoMedioPagoId = 1;
      }
    },
    errorPolitica: function () {
      // cargo los productos disponibles
      this.hayErroresPolitica = this.errorPolitica != "";
      this.model.motivoSolicitudAutorizacion = this.errorPolitica;
    },
    ingresoPorMonto: function () {
      if (this.ingresoPorMonto == "true") {
        this.importeCuotaMaximaIngresado = 0;
      } else {
        this.capitalIngresado = 0;
      }
    },
  },
  filters: {
    formatDate: function (value) {
      if (value) return format(value, "YYYY-MM-DD");
    },
  },
  computed: {
    ...mapGetters([
      "user",
      "UiCustomUserSettings",
      "DebugModeOn",
      "getActionFromLink",
    ]),
    subSituacionLaboralEmpleo: function () {
      return this.model.personaDto.empleo != null
        ? this.model.personaDto.empleo.subSituacionLaboralId
        : null;
    },
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    puedeModificarMedioCobro: function () {
      var plan = this.listPlanesDisponibles.find(
        (i) => i.planId == this.model.planId
      );

      return plan != null && !plan.requiereDebitoEnCuenta;
    },
    listCanalesVenta: function () {
      // devuelvo los canales de venta de la empresa seleccionada
      let canalesDisponibles = this.listCanalesVentaHabilitados.filter(
        (i) => i.empresaId == this.model.empresaId
      );

      return canalesDisponibles;
    },
    selectedEmpresa: function () {
      if (this.model.empresaId && this.model.empresaId > 0)
        return this.listEmpresas.find((i) => i.id === this.model.empresaId);

      return null;
    },
    selectedCanalVenta: function () {
      console.log(this.model.canalVentaId);
      if (this.model.canalVentaId && this.model.canalVentaId > 0)
        return this.listCanalesVentaHabilitados.find(
          (i) => i.id === this.model.canalVentaId
        );

      return null;
    },
    edad: function () {
      if (!this.persona) return "-";

      var dob = this.$moment(this.model.fechaNacimiento);

      if (dob.isValid) {
        var ageDifMs = Date.now() - dob.toDate().getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970) + " años";
      }
      return "-";
    },
    infoPersona: function () {
      if (!this.infoCrediticia) return null;

      var dob = this.$moment(this.model.personaDto.fechaNacimiento);

      var edad = "";
      if (dob.isValid) {
        var ageDifMs = Date.now() - dob.toDate().getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        edad = Math.abs(ageDate.getUTCFullYear() - 1970) + " años";
      }

      var info =
        "Solicitante " +
        this.infoCrediticia.tipoCalificacionDescripcion +
        ": " +
        this.model.personaDto.nombre +
        " " +
        this.model.personaDto.apellido +
        ", " +
        this.infoCrediticia.documentoCompleto +
        ", edad " +
        edad;
      return info;
    },
    infoEmpleo: function () {
      if (!this.infoCrediticia && !this.model.personaDto) return null;

      var info = "";
      if (!this.model.personaDto.empleo || this.model.personaDto.empleo == null)
        return "No tiene empleo cargado";

      //console.log('this.model.personaDto')
      //console.log(this.model.personaDto)
      switch (this.model.personaDto.tipoSituacionLaboralId) {
        case 0: // nuevo
          info = "Situación Laboral no especificada";
          break;
        case 1: // relación de dependencia
          if (this.model.personaDto.empleo.empleador == "")
            info = "No registra empleo ";
          else info = "Trabaja en " + this.model.personaDto.empleo.empleador;
          break;
        case 2: // autónomo
        case 3: // monotributista
        case 4: // jubi
          info =
            "Es " +
            this.listSituacionesLaborales.find(
              (i) => i.id === this.model.personaDto.tipoSituacionLaboralId
            ).descripcion;
        case 5: // fuerzas
          info =
            "Pertenece a las " +
            this.listSituacionesLaborales.find(
              (i) => i.id === this.model.personaDto.tipoSituacionLaboralId
            ).descripcion;
        case 6: // fuerzas
          info = "Realiza otras actividades ";
        default:
          info =
            "Es " +
            this.listSituacionesLaborales.find(
              (i) => i.id === this.model.personaDto.tipoSituacionLaboralId
            ).descripcion;
          break;
      }

      if (this.model.personaDto.empleo.ingresoNeto > 0) {
        info =
          info +
          " con un ingreso mensual de $ " +
          this.model.personaDto.empleo.ingresoNeto;
      } else {
        info = info + ", no registra ingresos";
      }

      return info;
    },
    infoconsultaCredito: function () {
      if (!this.model.consultaCredito) return null;

      var info =
        "El resultado de la Consulta fue " + this.model.consultaCredito.estado;

      if (
        this.model.consultaCredito.estado.includes("APROBADO") ||
        this.model.consultaCredito.estado.includes("INGRESADA")
      )
        if (this.model.consultaCredito.cupo == 0)
          info = info + ", pero requiere posterior análisis";
        else
          info = info + ", con un CUPO de $ " + this.model.consultaCredito.cupo;

      return info;
    },
    infoCredito: function () {
      if (this.cuotaSeleccionada == 0)
        return "No se seleccionó la cantidad de cuotas";

      return (
        "Se está solicitando un monto de $" +
        this.model.capital +
        " en " +
        this.cuotaSeleccionada.cuotas +
        " de $ " +
        this.cuotaSeleccionada.importeCuota
      );
    },
    hayProductosNoDisponibles: function () {
      return (
        this.listProductos &&
        this.listProductos.filter((p) => !p.estaDisponible).length > 0
      );
    },
    hayPlanesNoDisponibles: function () {
      return (
        this.listPlanes &&
        this.listPlanes.filter((p) => !p.estaDisponible).length > 0
      );
    },
    puedeContinuarPaso2: function () {
      return (
        this.model.consultaCredito &&
        (this.model.consultaCredito.estado.includes("APROBADO") ||
          this.model.consultaCredito.estado.includes("INGRESADA"))
      );
    },
    puedeContinuarPaso3: function () {
      return (
        this.model.cuotas &&
        this.model.cuotas > 0 &&
        this.model.planId &&
        this.model.planId > 0
      );
    },
    tieneConsultasAprobadas: function () {
      return this.listConsultasAprobadas.length > 0;
    },
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    async nextStep(currentStep) {
      if (currentStep == 1) {
        if (!this.model.productoId || this.model.productoId == 0) {
          this.alertError(
            "Antes de continuar, seleccione el Producto a solicitar"
          );
          return;
        }

        if (!this.infoCrediticia) {
          this.alertError(
            "Antes de continuar, realice la búsqueda del solcitante (con la lupita al lado del documento)"
          );
          return;
        }

        let result = await this.$refs.paso1.validate();
        if (!result) {
          this.alertWarning(
            "Por favor, complete los datos requeridos para continuar."
          );
          return;
        }

        await this.ingresarConsultaCredito();
      } else if (currentStep == 2) {
        this.step++;
      } else if (currentStep == 3) {
        let result = await this.$refs.paso3.validate();
        if (!result) {
          this.alertWarning(
            "Por favor, complete los datos requeridos para continuar."
          );
          return;
        }

        if (
          this.model.consultaCredito.topeProducto > 0 &&
          this.model.consultaCredito.topeProducto < this.capitalIngresado
        ) {
          this.alertWarning(
            "Por favor, ingrese un importe de capital menor a " +
              this.model.consultaCredito.topeProducto +
              ", ya que es el máximo aprobado."
          );
          return;
        }

        if (
          this.model.consultaCredito.cupo > 0 &&
          this.model.consultaCredito.cupo < this.importeCuotaMaximaIngresado
        ) {
          this.alertWarning(
            "Por favor, ingrese un importe de cuota menor a " +
              this.model.consultaCredito.cupo +
              ", ya que es el máximo aprobado."
          );
          return;
        }

        if (
          this.model.modificaOferta &&
          this.model.motivoModificacionOferta == "" &&
          this.model.importeCuota > this.model.consultaCredito.cupo
        ) {
          this.alertWarning(
            "Por favor, ingrese el motivo por el cual solicita modificar la oferta."
          );
          return;
        }

        this.step++;
      }
    },
    async retomarConsulta(consulta) {
      console.log("retomar consulta");
      console.log(consulta);
      this.model.personaId = this.model.personaDto.id;
      this.model.productoId = consulta.productoId;

      this.model.consultaCredito.cupo = consulta.cupo;
      this.model.consultaCredito.id = consulta.id;
      this.model.consultaCredito.topeProducto = consulta.topeProducto;

      if ((consulta.solicitanteId = "00000000-0000-0000-0000-000000000000")) {
        this.model.personaDto.nombre = consulta.nombre;
        this.model.personaDto.apellido = consulta.apellido;
      }

      this.model.personaDto.empleo.ingresoNeto = consulta.ingresoMensual;

      this.model.consultaCredito.estado = "APROBADA CON CUPO";

      this.captionStep2 = "";
      this.captionStep3 = "Carga Completa";
      this.captionStep4 = "Datos Finales";

      await this.loadPlanesDisponibles();

      if (consulta.planId > 0) {
        this.model.planId = consulta.planId;
        //todo: bloquear planDiaCobroId
        await this.setPoliticaComercial(); // vuelvo a calcula la politica porque cambia el plan
      }

      if (this.model.consultaCredito.topeProducto > 0) {
        this.ingresoPorMonto = "true";
        this.capitalIngresado = this.model.consultaCredito.topeProducto;
        await this.calcularOpcionesPlan();
      } else if (this.model.consultaCredito.cupo > 0) {
        this.ingresoPorMonto = "false";
        this.importeCuotaMaximaIngresado = this.model.consultaCredito.cupo;
        await this.calcularOpcionesPlan();
      }
      this.showConsultasAprobadas = false;

      this.step = 3;
    },
    async confirmarAlta() {
      if (!this.politicaAprobada) {
        this.alertWarning(
          "La Política no ha sido validada. Imposible continuar."
        );
        return;
      }

      if (!this.legajoCheck) {
        this.alertWarning(
          "Por favor, revise y complete el Legajo de Solicitante antes de confirmar."
        );
        return;
      }

      if (this.showAgregar && this.archivosASubir.length == 0) {
        this.alertWarning(
          "Por favor, adjunte los archivo necesarios para el análisis de la solicitud."
        );
        return;
      }

      if (this.model.solicitaDebito) {
        if (!this.model.cuentaDebito) {
          this.alertWarning(
            "Por favor, ingrese los datos de la Cuenta de Débito."
          );
          return;
        }

        if (
          !this.model.cuentaDebito.debitoATitular &&
          !this.model.cuentaDebito.debitoAGarante
        ) {
          this.alertWarning(
            "Por favor, indique si el débito se realizará el Titular o al Garante."
          );
          return;
        }

        if (
          this.model.cuentaDebito.altaCuenta &&
          this.model.cuentaDebito.cbu == ""
        ) {
          this.alertWarning(
            "Por favor, ingrese los datos de la nueva Cuenta de Débito."
          );
          return;
        }

        if (
          !this.model.cuentaDebito.altaCuenta &&
          this.model.cuentaDebito.cuentaBancoId == null
        ) {
          this.alertWarning("Por favor, seleccione la Cuenta de Débito.");
          return;
        }

        if (!this.model.cuentaDebito.diaCobroId) {
          this.alertWarning("Por favor, seleccione el Día de Cobro.");
          return;
        }
      }

      this.loading = true;
      try {
        this.model.politicaComercialId = this.politicaComercial.id;
        this.model.consultaId = this.model.consultaCredito.id;
        this.model.personaId = this.model.personaDto.id;

        this.showSaveProgress = true;
        this.saving = true;
        this.uploading = true;

        var result = await http.post(
          "creditos/upgradefromconsulta",
          JSON.stringify({ solicitud: this.model })
        );

        this.saving = false;

        if (this.archivosASubir.length > 0) {
          await this.uploadFiles();
          this.uploading = false;
        }

        if (result.acciones) {
          var mensaje = "";
          for (let index = 0; index < result.acciones.length; index++) {
            const accion = result.acciones[index];
            mensaje = mensaje + accion + "<br>";
          }
          const res = await this.$dialog.confirm({
            text: mensaje,
            title: "Se realizaron las siguientes acciones",
            actions: {
              false: "",
              true: {
                text: "OK",
                color: "primary",
              },
            },
            persistent: true, // Parece que no funciona...
          });
        }

        this.clear();
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
      this.showSaveProgress = false;
    },
    async confirmarAltaConsulta() {
      if (
        !this.model.consultaCredito.estado.includes("APROBADO") &&
        !this.model.consultaCredito.estado.includes("INGRESADA")
      ) {
        this.alertWarning(
          "La consulta al Motor no fue APROBADA. Imposible continuar."
        );
        return;
      }

      if (this.showAgregar && this.archivosASubir.length == 0) {
        this.alertWarning(
          "Por favor, adjunte los archivo necesarios para el análisis de la solicitud."
        );
        return;
      }

      this.loading = true;
      try {
        var parametros = {
          creditoId: this.model.consultaCredito.id,
          motivo: this.model.observaciones,
          subEstadoId: 13, // Consulta - Para Analizar
        };

        this.showSaveProgress = true;
        this.saving = true;
        this.uploading = true;

        var result = await http.post(
          "creditos/cambiarestado",
          JSON.stringify({ parametros: parametros })
        );
        this.alertSuccess("La consulta de crédito ha sido registrada.");

        this.saving = false;

        if (this.archivosASubir.length > 0) {
          await this.uploadFiles();
          this.uploading = false;
        }

        this.clear();
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
      this.showSaveProgress = false;
    },
    async uploadFiles() {
      if (this.archivosASubir.length === 0) {
        this.alertWarning(
          "No se ha seleccionado ningún archivo para subir al legajo."
        );
        return;
      }

      const response = await legajoVirtualService.uploadLegajoVirtual(
        this.model.personaDto.documento,
        null,
        this.model.consultaCredito.id,
        this.model.empresaId,
        this.archivosASubirDocumentacion,
        false,
        "",
        "documentacion"
      );

      if (response.success) {
        this.alertSuccess(response.message);
        this.archivosASubir = [];
      } else {
        this.alertError(response.message);
        this.errorAlAgregarDocumentacion = true;
        return false;
      }

      // //this.loading = true;
      // const formData = new FormData();

      // //formData.append('personaId',this.personaId);
      // formData.append('documento',this.model.personaDto.documento);
      // formData.append('creditoId',this.model.consultaCredito.id);
      // formData.append('empresaId',this.model.empresaId);

      // for(let i = 0;i<this.archivosASubir.length;i++){
      //     formData.append('files',this.archivosASubir[i]);
      // }

      // try{
      //     await http.post('/personas/uploadfileslegajovirtual', formData );

      //     this.alertSuccess('Los archivos se subieron con éxito.');

      //     this.archivosASubir=[];
      // } catch(error) {
      //     // Error
      //     this.alertError(error)
      // }
      // //this.loading = false;
    },
    async setCuotaSeleciconada(item) {
      this.indiceOferta = item.indice;
      this.cuotaSeleccionada = item;
      this.model.capital = this.cuotaSeleccionada.capital;
      this.model.cuotas = this.cuotaSeleccionada.cuotas;
      this.model.importeCuota = this.cuotaSeleccionada.importeCuota;
      this.model.tablaCoeficientesId =
        this.cuotaSeleccionada.tablaCoeficienteId;
    },
    async selectedProductoChanged(value) {
      if (value == 0) return;

      await this.setPoliticaComercial();
    },
    async selectedPlanChanged(value) {
      if (value == 0) return;

      await this.setPoliticaComercial();
      await this.calcularOpcionesPlan();
    },
    async situacionLaboralChanged() {
      if (this.model.personaDto.empleo)
        this.model.personaDto.empleo.situacionLaboralId =
          this.model.personaDto.tipoSituacionLaboralId;
    },
    async retomarConsultaCredito(consultaId) {
      this.loading = true;
      try {
        var result = await http.get(
          "Creditos/getinforesumida?id=" + consultaId
        );

        if (result != null) {
          // veo si el usuario tiene el canal de venta de la consulta habilitado
          if (
            !this.listCanalesVentaHabilitados.find(
              (c) => c.id == result.canalVentaId
            )
          ) {
            this.alertError(
              "Atención, no tiene habilitado el Canal de Venta:" +
                result.canalVentaNombre +
                ", al que pertenece la consulta. Imposible Retomar."
            );
            return;
          } else {
            this.model.canalVentaId = result.canalVentaId;
          }

          this.ingresoPor = "cuil";
          this.model.cui = result.personaCuil;
          await this.buscarPersonaPorDocumento(this.model.cui);

          this.showConsultasAprobadas = true;
        } else {
          this.alertError("Atención, ID de consulta inválido:" + consultaId);
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async ingresarConsultaCredito() {
      this.loading = true;

      try {
        var parametros = {
          canalVentaId: this.model.canalVentaId,
          productoId: this.model.productoId,
          calificacionPersonaId: this.infoCrediticia.tipoCalificacionId,
          cuil: this.model.personaDto.cui,
          nombre: this.model.personaDto.nombre,
          apellido: this.model.personaDto.apellido,
          personaId: this.model.personaDto.id,
          ingresoMensual: this.model.personaDto.empleo.ingresoNeto,
          movimientos: this.model.movimientos,
          entidadFinancieraId: this.model.entidadFinancieraId,
        };

        var result = await http.post(
          "creditos/crearconsulta",
          JSON.stringify({ solicitud: parametros })
        );
        //console.log(result)
        this.model.consultaCredito = result.entity;

        if (
          this.model.consultaCredito.motorNombre &&
          this.model.consultaCredito.motorNombre != "" &&
          this.model.personaDto.nombre == ""
        ) {
          // si no se ingresó nombre, pero se pudo recuperar, lo cargo
          this.model.personaDto.nombre = this.model.consultaCredito.motorNombre;
        }

        if (
          this.model.consultaCredito.motorApellido &&
          this.model.consultaCredito.motorApellido != "" &&
          this.model.personaDto.apellido == ""
        ) {
          // si no se ingresó apellido, pero se pudo recuperar, lo cargo
          this.model.personaDto.apellido =
            this.model.consultaCredito.motorApellido;
        }

        if (
          this.model.consultaCredito.motorFechaNacimiento &&
          this.model.consultaCredito.motorFechaNacimiento != "" &&
          this.model.personaDto.fechaNacimiento ==
            this.$moment(new Date()).format("YYYY-MM-DD")
        ) {
          // si no se ingresó apellido, pero se pudo recuperar, lo cargo
          this.model.personaDto.fechaNacimiento =
            this.model.consultaCredito.motorFechaNacimiento;
        }

        if (this.model.consultaCredito.estado != "RECHAZADO") {
          if (
            this.model.consultaCredito.motorCuil &&
            this.model.consultaCredito.motorCuil != ""
          ) {
            if (this.model.personaDto.cui == 0) {
              this.model.personaDto.cui = this.model.consultaCredito.motorCuil;
            } else if (
              this.model.consultaCredito.motorCuil != this.model.personaDto.cui
            ) {
              //console.log(this.model.consultaCredito.motorCuil)
              //console.log(this.model.personaDto.cui)

              // no coincide el cuil cargado con el recuperado del motor, aviso
              const res = await this.$dialog.confirm({
                text: "El CUIL recuperado desde el Motor no coincide con el cargado en el Sistema. ¿Desea utilizar el del Motor?",
                title: "Atención",
                persistent: true, // Parece que no funciona...
              });

              if (res) {
                this.model.personaDto.cui =
                  this.model.consultaCredito.motorCuil;
              }
            }
          }
        }

        if (this.model.consultaCredito.estado == "RECHAZA") {
          this.alertError(
            "La consulta ha sido RECHAZADA. Puede ver más información en las Variables del Motor."
          );
          return false;
        } else if (this.model.consultaCredito.estado == "APROBADO CON CUPO") {
          this.captionStep2 = "";
          this.captionStep3 = "Carga Completa";
          this.captionStep4 = "Datos Finales";

          await this.loadPlanesDisponibles();

          if (this.model.consultaCredito.planId) {
            console.log("se asigno plan");
            this.model.planId = this.model.consultaCredito.planId;
          }

          if (this.model.consultaCredito.topeProducto > 0) {
            this.ingresoPorMonto = "true";
            this.capitalIngresado = this.model.consultaCredito.topeProducto;
            await this.calcularOpcionesPlan();
          } else if (this.model.consultaCredito.cupo > 0) {
            this.ingresoPorMonto = "false";
            this.importeCuotaMaximaIngresado = this.model.consultaCredito.cupo;
            await this.calcularOpcionesPlan();
          }

          this.step = 3;
        } else if (this.model.consultaCredito.estado == "APROBADO SIN CUPO") {
          this.captionStep2 = "Carga para Análisis";
          this.captionStep3 = "";
          this.captionStep4 = "";

          this.step = 2;
        } else if (this.model.consultaCredito.estado == "INGRESADA") {
          this.captionStep2 = "Carga para Análisis";
          this.captionStep3 = "";
          this.captionStep4 = "";

          this.step = 2;
        }
      } catch (error) {
        // Error
        this.alertError(error);
        return false;
      } finally {
        this.loading = false;
      }

      return true;
    },
    async loadConsultasAprobadas() {
      // busco las posibles consultas aprobadas para la persona
      this.listConsultasAprobadas = [];

      this.loadingProgress = true;
      try {
        var result = await http.get(
          "creditos/listconsultasaprobadasporpersona" +
            "?cui=" +
            this.model.cui +
            "&canalVentaId=" +
            this.model.canalVentaId
        );

        this.listConsultasAprobadas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingProgress = false;
    },
    async calcularOpcionesPlan() {
      this.opcionesPlanes = [];

      // console.log(this.ingresoPorMonto)
      // console.log(this.importeCuotaMaximaIngresado)
      // console.log(this.capitalIngresado)

      // if(this.ingresoPorMonto)
      //   this.importeCuotaMaximaIngresado = 0;
      // else
      //   this.capitalIngresado = 0;

      console.log("calcular opciones plan");
      console.log(this.model.consultaCredito);

      if (this.capitalIngresado == 0 && this.importeCuotaMaximaIngresado == 0)
        return;

      this.model.cuotas = 0;
      this.errorPolitica = "";

      this.loading = true;
      try {
        var result = await http.get(
          "businesscore/calcularopcionesplanparacredito" +
            "?planId=" +
            this.model.planId +
            "&empresaId=" +
            this.model.empresaId +
            "&canalVentaId=" +
            this.model.canalVentaId +
            "&calificacionPersonaId=" +
            this.infoCrediticia.tipoCalificacionId +
            "&politicaComercialId=" +
            this.model.politicaComercialId +
            "&diaCobro=" +
            "0" +
            "&capital=" +
            this.capitalIngresado +
            "&importeCuotaMaximo=" +
            this.importeCuotaMaximaIngresado +
            "&ingresoMensual=" +
            this.model.personaDto.empleo.ingresoNeto +
            "&fechaCarga=" +
            this.model.fechaCarga +
            "&excepcionAprobada=" +
            this.politicaAprobada +
            "&esComer=" +
            this.user.esComer +
            "&topeProducto=" +
            (this.model.consultaCredito
              ? this.model.consultaCredito.topeProducto
              : 0) +
            "&cuotaMaxima=" +
            (this.model.consultaCredito ? this.model.consultaCredito.cupo : 0)
        );

        this.opcionesPlanes = result.list;
        if (result.list.length == 0) {
          this.alertWarning(
            "No se encontraron opciones de cuota para el plan seleccionado."
          );
        }
      } catch (error) {
        if (JSON.stringify(error).includes("Politica")) {
          this.errorPolitica = error;
        } else {
          // Error
          this.alertError(error);
        }
      }
      this.loading = false;
    },
    async setPoliticaComercial() {
      // busco la política que se esá aplicando en base al producto o plan seleccionado
      if (
        this.$store.state.parametrosGenerales.politicaComercialPor == "producto"
      )
        if (!this.infoCrediticia || !(this.model.productoId > 0)) return;

      if (this.$store.state.parametrosGenerales.politicaComercialPor == "plan")
        if (!this.infoCrediticia || !(this.model.planId > 0)) return;

      this.loadingProgress = true;

      if (
        this.$store.state.parametrosGenerales.politicaComercialPor == "producto"
      ) {
        try {
          var result = await http.get(
            "businesscore/establecerpoliticacomercial" +
              "?productoId=" +
              this.model.productoId +
              "&empresaId=" +
              this.model.empresaId +
              "&canalVentaId=" +
              this.model.canalVentaId +
              "&calificacionPersonaId=" +
              this.infoCrediticia.tipoCalificacionId
          );

          console.log("Política x Producto:");
          console.log(result);

          this.politicaComercial = result;
          this.model.politicaComercialId = this.politicaComercial.id;
        } catch (error) {
          // Error
          this.alertError(error);
        }
      } else {
        try {
          var result = await http.get(
            "businesscore/establecerpoliticacomercial" +
              "?planId=" +
              this.model.planId +
              "&empresaId=" +
              this.model.empresaId +
              "&canalVentaId=" +
              this.model.canalVentaId +
              "&calificacionPersonaId=" +
              this.infoCrediticia.tipoCalificacionId
          );

          // console.log('Política x Plan:');
          // console.log(result)

          this.politicaComercial = result;
          this.model.politicaComercialId = this.politicaComercial.id;
        } catch (error) {
          // Error
          this.alertError(error);
        }
      }

      this.loadingProgress = false;
    },
    async loadPlanesDisponibles() {
      this.opcionesPlanes = [];
      this.loading = true;
      try {
        var result = await http.get(
          "businesscore/planesdisponiblesparacredito" +
            "?productoId=" +
            this.model.productoId +
            "&empresaId=" +
            this.model.empresaId +
            "&canalVentaId=" +
            this.model.canalVentaId +
            "&calificacionPersonaId=" +
            this.infoCrediticia.tipoCalificacionId
        );

        this.listPlanes = result.list;
        this.listPlanesDisponibles = this.listPlanes.filter(
          (p) => p.estaDisponible
        );
        if (result.list.length == 0) {
          this.model.planId = 0;
          this.alertWarning(
            "El producto seleccionado no tiene Planes vigentes que estén disponibles. Utilice otro producto."
          );
        } else {
          this.model.planId = result.list[0].planId;
          await this.setPoliticaComercial();
          await this.calcularOpcionesPlan();
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadProductosDisponibles() {
      if (this.model.canalVentaId == 0) return;

      this.opcionesPlanes = [];
      this.loading = true;
      try {
        var result = await http.get(
          "businesscore/productosdisponiblesparaconsultamotor" +
            "?empresaId=" +
            this.model.empresaId +
            "&canalVentaId=" +
            this.model.canalVentaId
        );

        this.listProductos = result.list;
        this.listProductosDisponibles = this.listProductos.filter(
          (p) => p.estaDisponible
        );
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async buscarPersonaPorDocumento(cui) {
      if (this.ingresoPor == "cuil" && cui.toString().length != 11) {
        this.alertError(
          "Por favor, verifique el CUIL ingresado, debe tener 11 dígitos."
        );
        return;
      }

      this.loading = true;

      try {
        var result = await http.get(
          "personas/listaporcui?cui=" + Number.parseFloat(cui)
        );
        if (result.count >= 1) {
          this.setPersonaBusqueda(result.list[0]);
        } else {
          if (cui.toString().length == 11)
            this.setPersonaBusqueda({
              id: "00000000-0000-0000-0000-000000000000",
              documento: 0,
              cui: cui,
              tipoSexoId: this.model.personaDto.tipoSexoId,
            });
          // nuevo ingreso
          else
            this.setPersonaBusqueda({
              id: "00000000-0000-0000-0000-000000000000",
              documento: cui,
              cui: 0,
              tipoSexoId: this.model.personaDto.tipoSexoId,
            }); // nuevo ingreso
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async legajoGuardado(confirmado) {
      this.showLegajo = false;
      if (confirmado) this.legajoCheck = true;
    },
    async setPersonaBusqueda(persona) {
      this.selectedPersonaBusqueda = persona;
      this.model.personaId = persona.id;

      // busco la info completa de la persona
      this.loadingProgress = true;
      try {
        var result = await http.get(
          "personas/infocrediticia?id=" +
            this.model.personaId +
            "&cuil=" +
            persona.cui +
            "&documento=" +
            persona.documento +
            "&sexoId=" +
            this.model.personaDto.tipoSexoId
        );
        this.infoCrediticia = result;

        // console.log('info crediticia')
        // console.log(this.infoCrediticia)

        this.model.personaDto = this.infoCrediticia.personaDto;
        if (this.model.personaDto.empleo) {
          this.model.personaDto.empleo.fechaIngreso = this.$moment(
            this.model.personaDto.empleo.fechaIngreso
          ).format("YYYY-MM-DD");
        }

        this.model.cui = this.infoCrediticia.cui;

        this.model.calificacionPersonaId =
          this.infoCrediticia.tipoCalificacionId;

        var dob = this.$moment(this.model.personaDto.fechaNacimiento).format(
          "YYYY-MM-DD"
        ); // Todo: ver qué pasa cuando graba
        this.model.personaDto.fechaNacimiento = dob;

        if (this.infoCrediticia.personaDto.tipoSituacionLaboralId > 0) {
          this.model.trabaja = "true";
        } else {
        }

        await this.setPoliticaComercial();
        await this.loadConsultasAprobadas();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingProgress = false;
    },
    async cancelar() {
      const res = await this.$dialog.confirm({
        text: "¿Confirmar la cancelación de la carga?",
        title: "Atención",
        persistent: true, // Parece que no funciona...
      });

      if (!res) {
        return;
      } else {
        this.clear();
      }
    },
    async clear() {
      this.infoCrediticia = null;
      this.legajoCheck = false;
      this.model = {
        personaId: null,
        empresaId: this.UiCustomUserSettings.empresaPredeterminadaId,
        canalVentaId: this.UiCustomUserSettings.canalVentaPredeterminadoId,
        personaDto: {
          tipoSexoId: 1,
          nombre: "",
          apellido: "",
          fechaNacimiento: this.$moment(new Date()).format("YYYY-MM-DD"),
          tipoSituacionLaboralId: 1,
          empleo: { tipoSituacionLaboralId: 1 },
          domicilios: [{}],
          datosContacto: { telefonos: [] },
        },
        trabaja: "false",
        ingresoMensual: 0,
        calificacionPersonaId: 0,
        planId: 0,
        politicaComercialId: 0,
        seAutorizoPorExcepcion: false,
        usuarioQueAutorizo: "",
        motivoAutorizacion: "",
        capital: 0,
        importeCuota: 0,
        importeCuotaMaxima: 0,
        cuotas: 0,
        diaCobroId: 0,
        //ingresoMensual: 0,
        showAgregar: false,
        archivosASubir: [],
        consultaCredito: { estado: "" },
        cbu: "",
        modificaOferta: false,
        motivoModificacionOferta: "",
        montoRenovacion: 0,
        montoRetencion: 0,
        cuentaDebito: {},
        solicitaDebito: false,
        tipoMedioPagoId: 1,
        fechaCarga: this.$moment(new Date()).format("YYYY-MM-DD"),
      };

      this.captionStep2 = "";
      this.captionStep3 = "";
      this.captionStep4 = "";

      this.listConsultasAprobadas = [];
      this.archivosASubir = [];

      this.step = 1;
    },
    async loadSituacionesLaborales() {
      this.loading = true;
      try {
        var result = await http.get("situacioneslaborales"); // traigo todas
        this.listSituacionesLaborales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSexo() {
      this.loading = true;
      try {
        var result = await http.get("tipossexo"); // traigo todas
        this.listSexos = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadDiasCobro() {
      this.loading = true;
      try {
        var result = await http.get("tiposdiacobro"); // traigo todas
        this.listDiasCobro = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadMediosPago() {
      this.loading = true;
      try {
        var result = await http.get("tiposmediopagocredito"); // traigo todas
        this.listMediosPago = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadFormasLlegada() {
      this.loading = true;
      try {
        var result = await http.get("tiposformallegada"); // traigo todas
        this.listFormasLlegada = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadDestinosCredito() {
      this.loading = true;
      try {
        var result = await http.get("tiposdestinocredito"); // traigo toda s
        this.listDestinosCredito = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEntidadesFinancieras() {
      this.loading = true;
      try {
        var result = await http.get("entidadesfinancieras"); // traigo todas
        this.listEntidadesFinancieras = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVentaHabilitados() {
      this.loading = true;
      try {
        var result = await http.get(
          "canalesventa/habilitadosparausuario?soloActivos=true&usuarioId=" +
            this.user.id
        ); // traigo todas
        this.listCanalesVentaHabilitados = result.list;

        // extraigo las empresas de los canales habilitados
        this.listEmpresas = Array.from(
          new Set(this.listCanalesVentaHabilitados.map((i) => i.empresaId))
        ).map((id) => {
          return {
            id: id,
            nombre: this.listCanalesVentaHabilitados.find(
              (s) => s.empresaId === id
            ).empresaDescripcion,
            color: this.listCanalesVentaHabilitados.find(
              (s) => s.empresaId === id
            ).empresaColor,
          };
        });

        // selecciono la empresa predefinida del usuario
        if (this.UiCustomUserSettings.empresaPredeterminadaId > 0) {
          if (
            this.listEmpresas.find(
              (i) => i.id === this.UiCustomUserSettings.empresaPredeterminadaId
            )
          ) {
            this.model.empresaId =
              this.UiCustomUserSettings.empresaPredeterminadaId;
          }
        }

        // selecciono el canal de venta predefinido del usuario
        if (this.UiCustomUserSettings.canalVentaPredeterminadoId > 0) {
          if (
            this.listCanalesVentaHabilitados.find(
              (i) =>
                i.id === this.UiCustomUserSettings.canalVentaPredeterminadoId
            )
          ) {
            this.model.canalVentaId =
              this.UiCustomUserSettings.canalVentaPredeterminadoId;
          }
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
